export default __webpack_public_path__ + "static/subset-SuisseIntl-Regular-6861a8e409cef40c6f20bdccdb1a053b.woff2";